import React, { useMemo } from 'react'

import { SxProps } from '@mui/material'
import {
  useEntityCategories,
  useMetricCategories
} from 'redux/hooks/Categories'

import ChipTabs from 'components_new/molecules/ChipTabs'
import { useTranslation } from 'language/translator'

interface Props {
  sx?: SxProps
  type: 'metric' | 'entity'
  variant?: 'default' | 'query'
  category: string | null
  setCategory: (category: string | null) => void
}

const useCategories = (type: 'metric' | 'entity') => {
  const entityCategories = useEntityCategories()
  const metricCategories = useMetricCategories()

  return useMemo(
    () => (type === 'metric' ? metricCategories : entityCategories),
    [type, entityCategories, metricCategories]
  )
}

const CategoryTabs = React.memo((props: Props) => {
  const { type, sx, category, setCategory } = props

  const categories = useCategories(type)
  const { lang } = useTranslation()

  return (
    <ChipTabs
      onChange={(value) => setCategory(value)}
      options={Object.values(categories).map((c) => {
        return {
          value: c.slug,
          label: c.title[lang]
        }
      })}
      value={category}
      size="medium"
      sx={sx}
    />
  )
})

export default CategoryTabs
